import { createContext, useContext } from "react";
import { content } from "@/i18n/content";

const LanguageContext = createContext({ lang: "es", t: content.es });

export const LanguageProvider = ({ lang, children }) => (
  <LanguageContext.Provider value={{ lang, t: content[lang] || content.es }}>
    {children}
  </LanguageContext.Provider>
);

export const useLang = () => useContext(LanguageContext);

export const otherLang = (lang) => (lang === "es" ? "en" : "es");
